<template>
  <b-card title="کسب درآمد">
    <b-tabs>
      <b-tab title="درآمد ها" active>
        <list-table
          :url="referalls.url"
          title="درآمد ها"
          :fields="referalls.fields"
          :params="referalls.params"
          :excelroute="''"
        >
        </list-table>
      </b-tab>
      <b-tab title="تسویه ها">
        <list-table
          :url="settels.url"
          title="تسویه ها"
          :fields="settels.fields"
          :params="settels.params"
          :excelroute="''"
        >
        </list-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<style>
.text-ltr {
  direction: ltr;
}
</style>
<script>
import moment from "jalali-moment";
import TableShowData from "../../../components/table";
export default {
  name: "Referrals",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      settels: {
        url: "~ref/api/v1/income/settles",
        fields: [
          {
            key: "referral_user",
            label: "پذیرنده",
          },
          {
            key: "amount",
            label: "مبلغ درخواستی",
            formatter(value, keu, item) {
              return Number(-1 * value).toLocaleString();
            },
          },
          {
            key: "sattlement_iban",
            label: "حساب واریزی",
          },
          {
            key: "request_date",
            label: "تاریخ درخواست",
            formatter(value, keu, item) {
              return moment(value).format("jYYYY/jMM/jDD H:m:s");
            },
            tdClass() {
              return "text-ltr";
            },
          },
          {
            key: "settled_date",
            label: "تاریخ تایید",
            formatter(value, keu, item) {
              if (value) {
                return moment(value).format("jYYYY/jMM/jDD H:m:s");
              }
              return "";
            },
            tdClass() {
              return "text-ltr";
            },
          },
          {
            key: "tracking_number",
            label: "کد رهگیری",
          },
        ],
        params: [],
      },
      referalls: {
        url: "~ref/api/v1/referral/accounters-report",
        fields: [
          {
            key: "referral_user",
            label: "معرفی کننده",
          },
          {
            key: "website_name",
            label: "وبسایت معرفی شده",
          },
          {
            key: "total_price",
            label: "مبلغ درآمد از این سایت",
            formatter(value, keu, item) {
              return Number(value).toLocaleString();
            },
          },
          {
            key: "wage_percent",
            label: "درصد پورسانت",
            formatter(value, keu, item) {
              return Number(value).toLocaleString() + '%';
            },
          },
        ],
        params: [],
      },
    };
  },
};
</script>
